import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "profile-logo",
    style: _normalizeStyle({ backgroundColor: $setup.logoBackgroundColor })
  }, _toDisplayString($setup.getWSNameLogoChar($props.WSName)), 5))
}